import React from 'react';
import classNames from 'classnames';
import { useVideoConfig } from '../../../video-config-provider';
import s from './tile-container.scss';
export var TileContainer = function (_a) {
    var _b;
    var children = _a.children, _c = _a.focused, focused = _c === void 0 ? false : _c, _d = _a.screenShare, screenShare = _d === void 0 ? false : _d, _e = _a.singleTile, singleTile = _e === void 0 ? false : _e, _f = _a.sharing, sharing = _f === void 0 ? false : _f;
    var _g = useVideoConfig(), mobile = _g.mobile, webinar = _g.webinar, sidePanelOpened = _g.sidePanelOpened, desktopUsedViewportHeight = _g.desktopUsedViewportHeight;
    var landscape = window.innerWidth > window.innerHeight;
    var tileMaxWidth = "calc((100vh - ".concat(desktopUsedViewportHeight, "px) / 0.5625)");
    return (React.createElement("div", { className: classNames(s.outerContainer, (_b = {},
            _b[s.mobile] = mobile,
            _b[s.desktop] = !mobile,
            _b[s.webinar] = webinar,
            _b[s.focused] = focused || screenShare || singleTile,
            _b[s.screenShare] = screenShare,
            _b[s.singleTile] = singleTile,
            _b[s.sidePanelOpened] = mobile && sidePanelOpened,
            _b[s.landscape] = landscape,
            _b[s.sharing] = sharing,
            _b)), style: { maxWidth: tileMaxWidth } },
        React.createElement("div", { className: s.innerContainer },
            React.createElement("div", { className: s.tile }, children))));
};
//# sourceMappingURL=tile-container.js.map